import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import groupDocuments from './groupDocuments';
import { DocumentDto } from '../../interfaces/Dto/DocumentDto';
import getApiRoot from '../../utils/getApiRoot';
import { DocumentGroupingDto } from '../../interfaces/Dto/DocumentGroupingDto';

export const DocumentListResourceInfo: ResourceInfo = {
  name: '/App.features.documents.documentsListResource',
  url: `${getApiRoot()}`,
  dataDst: '/App.features.documents.list.groups',
};

const DocumentListResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...DocumentListResourceInfo}
    {...props}
    config={{ withCredentials: true }}
    transformResponse={({ behaviours, data }: {
      behaviours: { documentGroupings: DocumentGroupingDto[] };
      data: DocumentDto[];
    }) => groupDocuments(data, behaviours.documentGroupings)}
  />
);

export default DocumentListResource;
